import { Bitcoin, ShieldCheck, Wrench, Car, Sparkle } from "lucide-react";
import { IMAGES } from "../data";

const POINTS = [
  {
    icon: Wrench,
    title: "6+ Years on the Tools",
    text: "Hands-on experience across German, Japanese and British marques — from classic ECUs to the latest gen-5 head units.",
  },
  {
    icon: Car,
    title: "Fully Mobile",
    text: "Your driveway, your office car park — we bring the workshop to you, fully equipped and insured.",
  },
  {
    icon: ShieldCheck,
    title: "Fully Insured Workmanship",
    text: "Every install is covered. We document the job, label the wiring, and leave your car cleaner than we found it.",
  },
  {
    icon: Bitcoin,
    title: "Crypto & Finance",
    text: "Pay how you want — card, bank, crypto. Interest-free finance available on any qualifying service.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#0A0C10] overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute -left-32 top-1/3 h-[500px] w-[500px] rounded-full bg-[#00A3FF]/10 blur-[160px]"
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* Left column — heading & image */}
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.24em] text-[#00F0FF] mb-5">
            / About AutoTech UK
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-white tracking-tighter leading-[1.05]">
            We take on the jobs{" "}
            <span className="text-gradient-cyan">others refuse.</span>
          </h2>
          <p className="mt-6 text-[#9CA3AF] leading-relaxed text-base">
            AutoTech UK is a London-based auto electronics specialist obsessed
            with doing things properly. We code, retrofit, rewire and secure
            vehicles for owners who care about detail — and we do it at prices
            that don't insult you.
          </p>

          <div className="mt-8 relative rounded-sm overflow-hidden border border-white/5 aspect-[4/5]">
            <img
              src={IMAGES.coding}
              alt="Automotive electronics and coding"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0C10] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/60 mb-1">
                Precision coding
              </div>
              <div className="font-heading text-xl text-white">
                Software, wiring & hardware — one team.
              </div>
            </div>
          </div>
        </div>

        {/* Right — value points */}
        <div className="lg:col-span-7 lg:pt-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {POINTS.map((p, i) => (
              <div
                key={i}
                data-testid={`about-point-${i}`}
                className="card-glow bg-[#12141C] border border-white/5 rounded-sm p-7"
              >
                <div className="h-10 w-10 rounded-sm bg-[#00F0FF]/10 border border-[#00F0FF]/20 grid place-items-center mb-5">
                  <p.icon className="h-5 w-5 text-[#00F0FF]" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-lg text-white font-medium">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-[#9CA3AF] leading-relaxed">
                  {p.text}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-10 p-8 border border-[#00F0FF]/25 bg-[#00F0FF]/[0.03] rounded-sm flex items-start gap-5">
            <Sparkle className="h-5 w-5 text-[#00F0FF] flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-heading text-lg text-white font-medium">
                Interest-free finance on every service.
              </h3>
              <p className="mt-2 text-sm text-[#9CA3AF] leading-relaxed max-w-xl">
                Spread the cost of your coding, retrofit or security install
                across monthly payments — subject to approval. Ask for details
                when you enquire.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
